import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    login: 'Log in',
    wiki: 'Wiki',
    online: 'online',
  },
  ru: {
    login: 'Войти',
    wiki: 'Вики',
    online: 'online',
  },
  uz: {
    login: 'Kirish',
    wiki: 'Viki',
    online: 'online',
  },
  fa: {
    login: 'ورود',
    wiki: 'ویکی',
    online: 'آنلاین',
  },
  pt: {
    login: 'Entrar',
    wiki: 'Wiki',
    online: 'online',
  },
  tr: {
    login: 'Giriş yap',
    wiki: 'Viki',
    online: 'online',
  },
  uk: {
    login: 'Увійти',
    wiki: 'Вікі',
    online: 'онлайн',
  },
  de: {
    login: 'Einloggen',
    wiki: 'Wiki',
    online: 'online',
  },
  es: {
    login: 'Iniciar sesión',
    wiki: 'Wiki',
    online: 'en línea',
  },
  pl: {
    login: 'Zaloguj się',
    wiki: 'Wiki',
    online: 'online',
  },
});
